import React, { useMemo } from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { Link } from 'react-router-dom'
import PagePaper from '../../components/mainFrame/PagePaper'
import { SECTIONS } from '../../navigation/sections'
import { getNavIcon } from '../../navigation/icons'
import { useVisiblePages } from '../../navigation/useNavigation'

// Every page the signed-in user can access, grouped the way global search
// labels them. Driven entirely by the navigation registry.
const Sitemap = () => {
  const { pages } = useVisiblePages()

  const sections = useMemo(() => {
    return SECTIONS.map((section) => ({
      ...section,
      pages: pages.filter((page) => page.section === section.id),
    })).filter((section) => section.pages.length > 0)
  }, [pages])

  return (
    <PagePaper>
      <Typography variant="h4" fontWeight={700} gutterBottom>
        Sitemap
      </Typography>
      <Typography color="text.secondary" mb={3}>
        Every page you can access in AmbuNet. You can also press{' '}
        <b>Cmd/Ctrl&nbsp;+&nbsp;K</b> anywhere to search for these.
      </Typography>

      <Stack spacing={4}>
        {sections.map((section) => (
          <Box key={section.id} id={section.id}>
            <Typography
              variant="overline"
              fontWeight={800}
              color="text.secondary"
              letterSpacing={1}
            >
              {section.title}
            </Typography>
            <Grid container spacing={1.5} mt={0}>
              {section.pages.map((page) => (
                <Grid item xs={12} sm={6} md={4} key={page.id}>
                  <Box
                    component={Link}
                    to={page.path}
                    sx={{
                      display: 'flex',
                      gap: 1.5,
                      alignItems: 'flex-start',
                      p: 1.5,
                      height: '100%',
                      borderRadius: 2,
                      border: '1px solid',
                      borderColor: 'divider',
                      textDecoration: 'none',
                      color: 'inherit',
                      '&:hover': {
                        backgroundColor: 'anMuted.main',
                        borderColor: '#94A3B8',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        color: '#1E7F88',
                        display: 'flex',
                        alignItems: 'center',
                        mt: 0.25,
                        '& svg': { fontSize: 20 },
                      }}
                    >
                      {getNavIcon(page.icon)}
                    </Box>
                    <Box minWidth={0}>
                      <Typography fontWeight={700} fontSize="0.9rem">
                        {page.title}
                      </Typography>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ display: 'block' }}
                      >
                        {page.description}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        ))}
      </Stack>
    </PagePaper>
  )
}

export default Sitemap
